/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable import/order */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable eqeqeq */
/* eslint-disable no-return-assign */
/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
import {
  ClickAwayListener,
  Grid,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  makeStyles,
} from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import { exportFormatedMoney } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import {
  mdiAlert,
  mdiClipboardTextClockOutline,
  mdiDelete,
  mdiDotsVertical,
  mdiNoteEditOutline,
} from '@mdi/js'
import Icon from '@mdi/react'
import colors from '../../../assets/colors'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { useDispatch, useSelector } from 'react-redux'
import { deleteProduct } from '../StockActions'
import Pagination from '../../../components/hooks/BasePagination'
import BasePopUp from '../../../components/hooks/BasePopUp'

const useStyles = makeStyles(theme => ({
  ref: {
    width: '34px',
    height: '34px',
    position: 'absolute',
    backgroundColor: '#FFFF',
    transform: 'rotate(45deg)',
    right: '7px',
    '&:hover': {
      backgroundColor: '#FFFF',
    },
  },
  menuList: {
    padding: '10px',
  },
  menuItem: {
    padding: '0 2px',
    height: 'auto',
    lineHeight: '1',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
  },
  menuItemLi: {
    padding: 0,
    margin: 0,
    borderRadius: 0,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
    fontSize: '14px',
  },
  menuItemLiIcon: {
    marginRight: '12px',
  },
  missingProduct: {
    color: colors.error,
    gap: '.4em',
  },
  tooltip: {
    backgroundColor: colors.error,
    fontSize: '14px',
    boxShadow: '0px 0px 7px 0px #00000040',
    '& .arrow': {
      color: colors.error,
    },
  },
}))

const List = ({ items = [], form, setForm }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const meta = useSelector(state => state.stock.meta)
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canUpdate, canRead, canDelete } = usePermissions()

  const [open, setOpen] = useState({
    id: '',
  })

  const [paginate, setPaginate] = useState({
    page: 1,
    per_page: 10,
  })

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [productToDelete, setProductToDelete] = useState({ id: null, name: '' })

  const handleChangeRowsPerPage = e => {
    const { value } = e.target

    setPaginate({
      ...paginate,
      per_page: value,
    })
  }

  const handleChangePage = (event, newPage) => {
    setPaginate({
      ...paginate,
      page: newPage,
    })
  }

  const anchorRefs = useRef([])

  const handleToggle = id => {
    if (open?.id === id) {
      return setOpen({
        id: '',
      })
    }

    setOpen({
      ...open,
      id: id,
    })
  }

  const handleClose = (event, index) => {
    if (
      anchorRefs.current[index] &&
      anchorRefs.current[index].contains(event.target)
    ) {
      return
    }

    setOpen({
      id: '',
    })
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen({
        id: '',
      })
    }
  }

  const handleOpenDeleteModal = (id = null, name = '') => {
    if (id) {
      setProductToDelete({ id, name })
    }
    setOpenDeleteModal(!openDeleteModal)
  }

  const handleConfirmDelete = () => {
    if (productToDelete.id) {
      dispatch(deleteProduct(productToDelete.id))
      setOpenDeleteModal(false)
      setProductToDelete({ id: null, name: '' })
    }
  }

  useEffect(() => {
    setForm({
      ...form,
      ...paginate,
    })
  }, [paginate])

  return (
    <>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <StyledTableCellHeader align="left">
                Produto
              </StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Em estoque
              </StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Medida
              </StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Valor em Estoque
              </StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Ações
              </StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.map(item => (
              <TableRow key={item?.id} hover>
                <StyledTableCellBody>{item?.name}</StyledTableCellBody>
                <StyledTableCellBody align="center">
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    className={item?.missing_product && classes.missingProduct}
                  >
                    <Grid item>{item?.actual_stock || '-'}</Grid>
                    {item?.missing_product && (
                      <Tooltip
                        title="Fazer pedido"
                        placement="right-start"
                        arrow
                        classes={{
                          tooltip: classes.tooltip,
                          arrow: 'arrow',
                        }}
                      >
                        <span>
                          <Grid item>
                            <Icon
                              path={mdiAlert}
                              size={1}
                              color={colors.info}
                            />
                          </Grid>
                        </span>
                      </Tooltip>
                    )}
                  </Grid>
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {item?.unit_measure}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {exportFormatedMoney(item?.price * item?.actual_stock)}
                </StyledTableCellBody>
                <StyledTableCellBody align="center">
                  <IconButton
                    ref={el => (anchorRefs.current[item?.id] = el)}
                    key={item.id}
                    id={item?.id}
                    aria-controls={
                      open?.id ? `menu-list-grow-${item.id}` : undefined
                    }
                    aria-haspopup="true"
                    onClick={() => {
                      handleToggle(item.id)
                    }}
                  >
                    <Icon path={mdiDotsVertical} size={1} />
                  </IconButton>

                  <Popper
                    open={open?.id === item?.id}
                    role={undefined}
                    anchorEl={anchorRefs.current[item?.id]}
                    transition
                    disablePortal
                    style={{
                      zIndex: 99999999,
                    }}
                    placement="bottom-end"
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement == 'bottom' ? 'left-end' : 'top-end',
                        }}
                      >
                        <Paper className={classes.paper}>
                          <ClickAwayListener onClickAway={handleClose}>
                            <MenuList
                              autoFocusItem={open?.id}
                              id={`menu-list-grow-${item.id}`}
                              onKeyDown={handleListKeyDown}
                              className={classes.menuList}
                            >
                              <MenuItem
                                className={classes.ref}
                                style={
                                  placement === 'bottom-end'
                                    ? { top: '-2px' }
                                    : { bottom: '-2px' }
                                }
                              />
                              {canUpdate('estoque', permissionUser) && (
                                <MenuItem
                                  onClick={handleClose}
                                  className={classes.menuItem}
                                >
                                  <IconButton
                                    component={Link}
                                    to={`/stock/product/edit/${item?.id}`}
                                    className={classes.menuItemLi}
                                  >
                                    <Icon
                                      path={mdiNoteEditOutline}
                                      size={1}
                                      className={classes.menuItemLiIcon}
                                    />
                                    Editar
                                  </IconButton>
                                </MenuItem>
                              )}

                              {canRead('estoque', permissionUser) && (
                                <MenuItem
                                  onClick={handleClose}
                                  className={classes.menuItem}
                                >
                                  <IconButton
                                    component={Link}
                                    to={`/product-history/${item?.id}`}
                                    className={classes.menuItemLi}
                                  >
                                    <Icon
                                      path={mdiClipboardTextClockOutline}
                                      size={1}
                                      className={classes.menuItemLiIcon}
                                    />
                                    Histórico
                                  </IconButton>
                                </MenuItem>
                              )}

                              {canDelete('estoque', permissionUser) && (
                                <MenuItem
                                  onClick={handleClose}
                                  className={classes.menuItem}
                                >
                                  <IconButton
                                    className={classes.menuItemLi}
                                    onClick={() =>
                                      handleOpenDeleteModal(item?.id, item?.name)
                                    }
                                  >
                                    <Icon
                                      path={mdiDelete}
                                      size={1}
                                      className={classes.menuItemLiIcon}
                                    />
                                    Excluir
                                  </IconButton>
                                </MenuItem>
                              )}
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Pagination
          from={meta?.from}
          to={meta?.to}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPage={paginate?.per_page}
          rows={meta?.total}
          page={paginate?.page}
          handleChangePage={handleChangePage}
        />
      </TableContainer>

      <BasePopUp
        open={openDeleteModal}
        type="error"
        title="Excluir Produto"
        message={`Deseja realmente excluir o produto: ${productToDelete.name}?`}
        handleOpen={handleOpenDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  )
}

export default List
